import  { FC } from 'react';
import { Button } from 'react-bootstrap';

interface GenericButtonProps {
    type: "button"|"submit"|"reset"|undefined, label: string, isPrimary?: boolean, className?:string, onClick: any, disabled?: boolean
}
const GenericButton: FC<GenericButtonProps> = ({type, label, isPrimary  = true, className, onClick, disabled = false }) => {
    return (
        <Button 
            type={type} variant={!isPrimary ? "outline-secondary" : ""}
            className={`${className} ${isPrimary ? "btn-primary" : ""} ? "btn-primary" : ""`}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </Button>
    );
};

export default GenericButton;